<div class="row">
  <div class="col text-muted">
    <div class="row">
      <div class="col">
        <p class="h5 mb-0">{{ 'document-view-public.document-view-payments.paid-using' | translate }}:</p>
      </div>
      <div class="col-auto text-right">
        <p class="h5 mb-0">
          <span *ngFor="let payment of payments">
            {{ 'payment.type-name.' + payment.type | translate }}
            <span *ngIf="payment.length > 1 || !paidInFull">({{ payment.amount | pepCurrency: currencyId }})</span>
            <br *ngIf="payments.length > 1">
          </span>
        </p>
      </div>
    </div>
  </div>
</div>